// Stacked cards / game-boards — used on the bolão tile to denote "# jogos".
const CardsIcon: React.FC<{ size?: string; color?: string }> = ({
  size = "14",
  color = "currentColor",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4.5" y="1" width="7.5" height="9" rx="1.5" fill={color} opacity="0.4" />
      <rect x="2" y="4" width="7.5" height="9" rx="1.5" fill={color} />
    </svg>
  );
};
export default CardsIcon;
